import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionsService } from './sessions.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { urlApi } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { AlertifyService } from '../api-service/alertify.service';
import { SessionService } from '../core/services/session/session.service';
import { CognitoService } from '../core/services/cognito/cognito.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private root = true;
  constructor(
    private sessionService: SessionsService,
    private auth: AuthService,
    private alertify: AlertifyService,
    private session: SessionService,
    private cognito: CognitoService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes(urlApi)) {
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          this.verificaStatusCode(event);
          return event;
        })
      );
    }

    const acessoExpirado = false;
    const usuarioLogado = this.cognito.usuarioLogado();

    if (request.method == 'GET' && !request.url.includes('PrestacaoConta')) {
      request = this.adicionaFiltros(request);
    }

    if (!usuarioLogado && acessoExpirado) {
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          this.verificaStatusCode(event);
          return event;
        })
      );
    }

    if (acessoExpirado && usuarioLogado) {
      this.auth.atualizaToken();
      return next.handle(this.adicionaToken(request)).pipe(
        map((event: HttpEvent<any>) => {
          this.verificaStatusCode(event);
          return event;
        })
      );
    }

    return next.handle(request);
  }

  private verificaStatusCode(event: HttpEvent<any>): void {
    if (event instanceof HttpResponse) {
      if (event.status === 401) {
        this.alertify.error(`Sessão expirada. Faça login`, 3);
        this.auth.logout();
      }

      if (event.status === 403) {
        this.alertify.error(`Permissão negada. Entre em contato com o administrador`, 3);
        this.auth.logout();
      }
    }
  }

  /**
   * Método clona a requisição e adiciona o Token da sessão.
   * @param request Requisição HTTP
   */
  private adicionaToken(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.session.getSessionJwt()}`,
      },
    });
  }

  /**
   * Método clona a requisição e adiciona o parâmetros de filtro.
   * @param request Requisição HTTP
   */
  private adicionaFiltros(request: HttpRequest<any>): HttpRequest<any> {
    const login = this.sessionService.getLogin();
    let params = request.params;
    let url = request.url;
    let antigo: boolean;

    if (url.match('/%3f')) {
      antigo = true;
    }

    if (!this.root) {
      // Se não for Root
      params = params.set('BilhetadoraId', login.bilhetadoraId.toString());
      params = params.set('Root', 'False');

      if (antigo) {
        url += `&BilhetadoraId=${login.bilhetadoraId}&Root=False`;
      }

      if (login.entidadePublicaId) {
        // Se for Entidade Pública
        params = params.set('EntidadePublicaId', login.entidadePublicaId.toString());
        if (antigo) {
          url += `&EntidadePublicaId=${login.entidadePublicaId}`;
        }
      }

      if (login.operadoraId) {
        // Se for Empresa de Transporte
        params = params.set('OperadoraId', login.operadoraId.toString());
        if (antigo) {
          url += `&OperadoraId=${login.operadoraId}`;
        }
      }
    } else {
      params = params.set('Root', 'True');
      if (antigo) {
        url += `&Root=True`;
      }
    }

    return request.clone({ params, url });
  }
}
